import BaseService from './base.service';

export default class AppConfig extends BaseService {
    constructor(ctx) {
        super(ctx);
    }

    getAppConfig = query => {
        return this.get('/app-config/pages', query);
    };
}
